(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tw-product-question-popup"] && !Shopify.designMode) return;
  try {
    if(tw_product_question_popup) {
    tw_product_question_popup.addEventListener('click', function(e) {
        if(e.target === tw_product_question_popup) {
            tw_product_question_popup.style.display = 'none';
        }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
